import {
  useConstraints,
  useEffect,
  useElement,
  usePromise,
  useRect,
  useSelections,
  useStaleLayout,
  useState,
  useTheme,
} from "@nebula.js/stardust";
import type { Network } from "vis-network";
import type { SnNetworkChartLayout } from "../tsp-output/types";
import defaults from "../tsp-output/defaults.json";
import data from "./extension/data";
import ext from "./extension/ext";
import paint from "./paint";

import "./styles/main.css";

export default function supernova() {
  return {
    qae: {
      properties: defaults,
      data: data(),
    },
    component() {
      const layout = useStaleLayout() as SnNetworkChartLayout;
      const element = useElement();
      const theme = useTheme();
      const rect = useRect();
      const constraints = useConstraints();
      const selections = useSelections();
      const [network, setNetwork] = useState<Network | undefined>(undefined);

      useEffect(() => {
        network?.fit();
      }, [network, rect.width, rect.height]);

      usePromise(
        () => paint({ element, layout, theme, constraints, selections }).then(setNetwork),
        [layout, element, theme.name(), constraints, selections],
      );
    },
    ext: ext(),
  };
}
